import { apiConfigs } from "../../constants/apiConfigs";
import { CollaborationChatRoom } from "../../types/collaborations/chat";
import axiosClient from "../../utils/axiosClient";

export const getBackendTokenForFirebase = async () : Promise<string> => {
    try {
        const response = await axiosClient.post(apiConfigs.CREATE_FIREBASE_TOKEN.url);
        return response.data.token;
    } catch (error) {
        console.error("Failed to fetch firebase custom token", error);
        throw error;
    }
}


export const getCollabChatRoom = async (
    campaignId: string,
): Promise<CollaborationChatRoom> => {
    const response = await axiosClient.post(
        apiConfigs.COLLAB_CHAT_ROOM.url
            .replace('<campaignId>', campaignId)
    )
    return response.data;
}